import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";

import { RESOURCE_KEYS } from "../../../localization";
import { assertNonNullable } from "../../../utilities/assert";

import { cancelArchival } from "../actions";

export function EldoradoCancelModal(props: View) {
	const dispatch = useDispatch();
	const { localizer } = React.useContext(LocalizerContext);
	const { activityId } = props;

	const activity = useSelector(ActivitySelectors.activityById(activityId));
	if (!activity) {
		return undefined;
	}

	const jobUuid = activity.descriptor.jobUuid;
	assertNonNullable(jobUuid);

	const documentReference = activity.descriptor.instance;
	assertNonNullable(documentReference);

	return (
		<ModalNotification
			title={localizer({ key: RESOURCE_KEYS.features.modals.eldorado.forceCancelModalTitle })}
			variant="warning"
			enableCloseButton
			footer={
				<ButtonGroup alignment="right">
					<Button
						label="Schließen"
						primary={true}
						onClick={() => {
							dispatch(ActivityActions.cancel({ activityId }));
						}}
					/>
					<Button
						label="Veraktung abbrechen"
						secondary={true}
						onClick={() => {
							dispatch(
								cancelArchival({
									documentReference,
									activityId,
									implicit: true,
									closeActivity: true,
									reopenWorkflowsActivities: true
								})
							);
						}}
						primary
					/>
				</ButtonGroup>
			}
		>
			<p>{localizer({ key: RESOURCE_KEYS.features.modals.eldorado.forceCancelModalText })}</p>
		</ModalNotification>
	);
}
